import ConsumerTable from "./ConsumerTable";

export default ConsumerTable;
